<div class="prev" *transloco="let tr; prefix: 'productDefinitions.media'; scope: 'product-definitions'" [attr.aria-label]="tr('preview.title')">
  <span class="prev-title">{{ tr('preview.title') }}</span>
  <div class="prev-row">
    <div class="prev-main">
      @if (main(); as m) {
        <hc-media-thumb [thumb]="m.thumb" [kind]="m.kind"></hc-media-thumb>
        @if (mainIsVideo()) {
          <span class="play" aria-hidden="true"><hc-media-icon name="play" [size]="16"></hc-media-icon></span>
        }
      } @else if (legacyUrl() && !legacyBroken()) {
        <img class="legacy-pic" [src]="legacyUrl()" alt="" draggable="false" (error)="legacyBroken.set(true)" />
      } @else {
        <span class="legacy-empty"><hc-media-icon name="image" [size]="24" [width]="1.5"></hc-media-icon></span>
      }
    </div>
    <div class="prev-side">
      <span class="help">{{ tr('preview.page') }}</span>
      @if (mainWaits()) {
        <span class="help soon" role="status">{{ tr('preview.soon') }}</span>
      }
      <div class="thumbs">
        @for (t of published(); track t.key; let first = $first) {
          <span class="mini" [class.first]="first">
            <hc-media-thumb [thumb]="t.thumb" [kind]="t.kind" [iconSize]="16"></hc-media-thumb>
            @if (t.kind === 'VIDEO') {
              <span class="mini-play" aria-hidden="true"><hc-media-icon name="play" [size]="12"></hc-media-icon></span>
            }
          </span>
        }
      </div>
    </div>
  </div>
  <div class="prev-foot">
    <span class="cart-pic">
      @if (main(); as m) {
        <hc-media-thumb [thumb]="m.thumb" [kind]="m.kind" [iconSize]="16"></hc-media-thumb>
      } @else if (legacyUrl() && !legacyBroken()) {
        <img class="legacy-pic" [src]="legacyUrl()" alt="" draggable="false" />
      }
    </span>
    <span class="help dark">{{ tr('preview.where') }} {{ mainIsVideo() ? tr('preview.cover') : tr('preview.photo') }}</span>
  </div>
</div>
